














import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'

import { Page } from '@spa/store/modules/orderHistory/types'

@Component
export default class HistoryPagination extends Vue {
  @Prop({ required: true })
  page: Page

  get isFirstPage(): boolean {
    return !!this.page && this.page.pageNumber === 1
  }

  onPreviousPageClick() {
    if (!this.page) {
      return
    }

    this.newPageSelected(this.page.pageNumber - 1)
  }

  onNextPageClick() {
    if (!this.page) {
      return
    }

    this.newPageSelected(this.page.pageNumber + 1)
  }

  @Emit()
  newPageSelected(_pageNumber: number) {
    // Do nothing
  }
}
